/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2021 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


import React, { Component } from "react";
import asyncCallHandler from '../../common/utils/asyncCallHandler'
import EDW_CONST from '../../common/constants';
import style from '../../component/common/style/index.scss';
import { EdwLoaderWithContainer } from '../common/edwLoaderWithContainer/EdwLoaderWithContainer'
import {EdwTooltip} from '../common/ToolTip/EdwTooltip'
import { ErrorData,EmptyData } from "../common/noData/NoData";
export class StudentsBelowTarget extends Component {
    constructor(props) {
        super();
        this.state = {
            isDataLoaded: false,
            studentData: [],
            IsApiFail:false
        }
        this.iesToken = props.token ? props.token : '';
        this.activeAssessmentId = props.assessmentId;
    }

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.props.groupId !== prevProps.groupId ||
            this.props.studentYear !== prevProps.studentYear
        ) {
            this.fetchData();
        }
    }


    fetchData = () => {
        let { assessmentId, groupId, schoolId, dateTaken, studentYear } = this.props;

        asyncCallHandler(EDW_CONST.ASSESSMENT_END_POINT, `studentsBelowGradeData?assessmentId=${assessmentId}&groupId=${groupId}&examDate=${dateTaken}&schoolId=${schoolId}&studentYear=${studentYear}`, this.iesToken).then(data => {
            this.setState({ isDataLoaded: true, studentData: data.data });
        }).catch((error) => {
            this.setState({ studentData: [], IsApiFail:true });
        });
    }

    getStudentList = () => {
        let tpl = this.state.studentData.map(data => {
            return <div key={data.id} className="row">
                <div className={"col-md-12"}>
                    <a href={'/student/' + data['id']} className={[style.edwLabel,style.addLine].join(" ")} style={{
                        fontSize: 16,
                        fontFamily: 'OpenSans',
                        fontWeight: 600,
                        lineHeight: 1.75,
                        padding: 3,
                        display: "inline-block",
                        borderBottomWidth: 1.5,
                        // width: '38%'
                    }}>
                        {data['firstName'] + ' ' + data['lastName']}
                    </a>
                    <div className={style.thinLine}></div>
                </div>
            </div>
        })
        return tpl;
    }

    render() {

        return (

            <div className="col">
                <div className="row">
                    <div className="col-md-12">
                        <span className="edw-widget-chart-title">Students below target – {this.state.studentData.length} students
                             <EdwTooltip title="The assessment result indicates the student is ‘below’ track to meet their course target. Based on linear progress from baseline to course target." >
                            </EdwTooltip>
                        </span>
                    </div>
                </div>

                {/*{this.state.studentData.map(data => {
                    return <div key={data.id} className="row"><div className="col-md-12"><a href={'student/' + data['id']} className={style.edwLabel}>
                        {data['firstName'] + ' ' + data['lastName']} </a>
                    </div>
                    </div>


                }
                )
                }*/}
                {(!this.state.isDataLoaded && !this.state.IsApiFail) ? <div className="edw-full-width"><EdwLoaderWithContainer /></div> : (this.state.isDataLoaded && this.state.studentData.length > 0 && !this.state.IsApiFail) ? this.getStudentList() : (this.state.isDataLoaded && this.state.studentData.length == 0 && !this.state.IsApiFail) ? <EmptyData message={EDW_CONST.STU_BELOW_EMPTY_MSG}/>: <ErrorData/> }

            </div>


        );
    }
}


